module.exports = __webpack_public_path__ + "img/github.d4d93eb2.svg";